import PropTypes from 'prop-types';
import React from 'react';
import Heading from './Heading';
export const PageSubtitle = props => /*#__PURE__*/React.createElement(Heading, props);
PageSubtitle.propTypes = {
  ...Heading.propTypes,
  children: PropTypes.string.isRequired
};
PageSubtitle.defaultProps = {
  as: 'h2',
  fontSize: ['mobileSubtitle', 'subtitle'],
  mb: 3,
  textAlign: ['center', 'left']
};
PageSubtitle.displayName = 'PageSubtitle';
export default PageSubtitle;